import React, { Suspense } from 'react';
import Loader from '../../helpers/loader/loader.component';

function NewRegulatoryAgencyProgramLandingPage({
  page: { MainContent, breadCrumbList },
}) {
  const HeroComponent = React.lazy(() =>
    import('./new-regulatory-agency-program-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-regulatory-agency-program-content-component')
  );

  return (
    <div>
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewRegulatoryAgencyProgramLandingPage;
